import React from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ChevronRightRounded } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

const SideMenuButton = ({ to, children, startIcon = null, isHome, open, toggleMobileMenu }) => {
  const theme = useTheme();
  return (
    <ListItemButton
      key={to}
      component={RouterLink}
      to={to}
      disabled={children === "Leaderboard" ? true : false}
      onClick={() => toggleMobileMenu(false)}
      sx={{
        color: "white",
        padding: `${theme.customSpacing.md} ${theme.customSpacing.lg}`,
        backgroundColor: "transparent",
        borderRadius: theme.shape.borderRadius,
        justifyContent: open ? "flex-start" : "center",
        "&:hover": {
          backgroundColor: theme.palette.background.brand_alt,
          color: theme.palette.text.button_hover,
          "& .menu-icon path": {
            stroke: theme.palette.text.button_hover,
          },
        },
      }}
    >
      <ListItemIcon
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...(open && { marginRight: theme.customSpacing["lg"] }),
          "& svg": {
            color: theme.palette.background.brand_alt,
            strokeWidth: 1.67,
            transition: "stroke 0.3s ease",
          },
        }}
      >
        {startIcon}
      </ListItemIcon>
      <ListItemText
        primary={children}
        primaryTypographyProps={{
          sx: {
            display: open ? "block" : "none",
            whiteSpace: "nowrap",
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.textMD.fontSize,
            fontWeight: theme.typography.fontWeightMedium,
          },
        }}
      />
      {open && !isHome && (
        <ChevronRightRounded
          sx={{ color: "inherit", marginLeft: theme.customSpacing["lg"] }}
        />
      )}
    </ListItemButton>
  );
};

export default SideMenuButton;
